import { render, staticRenderFns } from "./ScratchCard.vue?vue&type=template&id=6deb3ac9&scoped=true"
import script from "./ScratchCard.vue?vue&type=script&lang=js"
export * from "./ScratchCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deb3ac9",
  null
  
)

export default component.exports